import {
    partnerEngagementChatSystemNoticeSchema,
    type EngagementChatSystemNotice,
    type PartnerEngagementChatSystemNotice,
} from '@houzy/schemas/partner-cockpit/chat';

const SYSTEM_NOTICE_TRANSLATION_KEYS = {
    ContactRequestSent: 'OFFER_REQUESTS.CHAT.SYSTEM.CONTACT_REQUEST_SENT',
    ContactViaPhoneEmail: 'OFFER_REQUESTS.CHAT.SYSTEM.CONTACT_VIA_PHONE_EMAIL',
    ContactRequestAccepted: 'OFFER_REQUESTS.CHAT.SYSTEM.CONTACT_REQUEST_ACCEPTED',
} as const satisfies Record<PartnerEngagementChatSystemNotice, string>;

export function systemNoticeTranslationKey(notice: EngagementChatSystemNotice | null): string | undefined {
    if (!notice) {
        return undefined;
    }
    return (SYSTEM_NOTICE_TRANSLATION_KEYS as Partial<Record<EngagementChatSystemNotice, string>>)[notice];
}

export function systemNoticesMissingTranslationKeys(): EngagementChatSystemNotice[] {
    return partnerEngagementChatSystemNoticeSchema.options.filter((notice) => !systemNoticeTranslationKey(notice));
}
